import { environment } from '../../../environments/environment';

/** Max concurrent work tabs — from `environment.features.maxOpenWorkTabs`. */
export const BROWSER_TAB_MAX_COUNT = environment.features.maxOpenWorkTabs;
